
import { Check } from "lucide-react";
import { Link } from "react-router-dom";

interface PricingCardProps {
  title: string;
  description: string;
  price: string;
  period?: string;
  features: string[];
  primaryCTA: {
    text: string;
    link: string;
  };
  delay?: number;
  backgroundColor?: string;
}

const PricingCard = ({ 
  title, 
  description, 
  price, 
  period, 
  features, 
  primaryCTA,
  delay = 0,
  backgroundColor
}: PricingCardProps) => {
  return (
    <div 
      className={`rounded-2xl mobile-card flex flex-col transition-all duration-500 px-6 py-8 ${
        backgroundColor || 'bg-white border border-joerg-100 shadow-soft'
      }`}
      style={{ 
        animationDelay: `${delay}ms`,
      }}
    >
      <h3 className="text-xl font-semibold text-center text-joerg-800">
        {title}
      </h3>
      <p className="mt-2 text-center text-joerg-600">
        {description}
      </p>
      
      <div className="mt-6 flex items-baseline justify-center">
        <span className="text-3xl sm:text-4xl font-bold text-joerg-800">
          {price}
        </span>
        {period && (
          <span className="ml-1 text-sm text-joerg-500">
            / {period}
          </span>
        )}
      </div>
      
      <ul className="mt-6 space-y-4 flex-grow">
        {features.map((feature, index) => (
          <li key={index} className="flex items-start gap-3">
            <div className="flex items-center justify-center mt-0.5">
              <Check className="h-5 w-5 flex-shrink-0 text-primary" />
            </div>
            <span className="text-joerg-600">
              {feature}
            </span>
          </li>
        ))}
      </ul>
      
      <Link 
        to={primaryCTA.link} 
        className="mt-8 text-center rounded-full py-3 px-6 font-medium mobile-touch-target bg-primary hover:bg-primary/90 text-primary-foreground transition-colors"
      >
        {primaryCTA.text}
      </Link>
    </div>
  );
};

export default PricingCard;
